/* eslint-disable import/prefer-default-export */

// ----------------------------------------------------------------------------------------ADMIN

export const FETCH_DISTRICS_LIST_REQUEST = 'FETCH_DISTRICS_LIST_REQUEST';
export const FETCH_DISTRICS_LIST_SUCCESS = 'FETCH_DISTRICS_LIST_SUCCESS';
export const FETCH_DISTRICS_LIST_FAILURE = 'FETCH_DISTRICS_LIST_FAILURE';

// ----------------------------------------------------------------------------------------

export const SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE';
export const SET_LOCALE_START = 'SET_LOCALE_START';
export const SET_LOCALE_SUCCESS = 'SET_LOCALE_SUCCESS';
export const SET_LOCALE_ERROR = 'SET_LOCALE_ERROR';

export const FETCH_DISTRICT_REQUEST = 'FETCH_DISTRICT_REQUEST';
export const FETCH_DISTRICT_SUCCESS = 'FETCH_DISTRICT_SUCCESS';
export const FETCH_DISTRICT_FAILURE = 'FETCH_DISTRICT_FAILURE';

export const FETCH_ALL_DISTRICTS_REQUEST = 'FETCH_ALL_DISTRICTS_REQUEST';
export const FETCH_ALL_DISTRICTS_SUCCESS = 'FETCH_ALL_DISTRICTS_SUCCESS';
export const FETCH_ALL_DISTRICTS_FAILURE = 'FETCH_ALL_DISTRICTS_FAILURE';

export const FETCH_ALL_ESERVICES_REQUEST = 'FETCH_ALL_ESERVICES_REQUEST';
export const FETCH_ALL_ESERVICES_SUCCESS = 'FETCH_ALL_ESERVICES_SUCCESS';
export const FETCH_ALL_ESERVICES_FAILURE = 'FETCH_ALL_ESERVICES_FAILURE';

export const FETCH_DISTRICT_COMPOSITIONS_REQUEST = 'FETCH_DISTRICT_COMPOSITIONS_REQUEST';
export const FETCH_DISTRICT_COMPOSITIONS_SUCCESS = 'FETCH_DISTRICT_COMPOSITIONS_SUCCESS';
export const FETCH_DISTRICT_COMPOSITIONS_FAILURE = 'FETCH_DISTRICT_COMPOSITIONS_FAILURE';

// ---------------------------------------------------------------------------------------------------------------NOWE
export const FETCH_DISTRICT_ROLES_REQUEST = 'FETCH_DISTRICT_ROLES_REQUEST';
export const FETCH_DISTRICT_ROLES_SUCCESS = 'FETCH_DISTRICT_ROLES_SUCCESS';
export const FETCH_DISTRICT_ROLES_FAILURE = 'FETCH_DISTRICT_ROLES_FAILURE';
export const FETCH_DISTRICT_FEATURES_REQUEST = 'FETCH_DISTRICT_FEATURES_REQUEST';
export const FETCH_DISTRICT_FEATURES_SUCCESS = 'FETCH_DISTRICT_FEATURES_SUCCESS';
export const FETCH_DISTRICT_FEATURES_FAILURE = 'FETCH_DISTRICT_FEATURES_FAILURE';
export const FETCH_DISTRICT_LAYERS_REQUEST = 'FETCH_DISTRICT_LAYERS_REQUEST';
export const FETCH_DISTRICT_LAYERS_SUCCESS = 'FETCH_DISTRICT_LAYERS_SUCCESS';
export const FETCH_DISTRICT_LAYERS_FAILURE = 'FETCH_DISTRICT_LAYERS_FAILURE';
export const FETCH_DISTRICT_EXTERNALLAYERS_REQUEST = 'FETCH_DISTRICT_EXTERNALLAYERS_REQUEST';
export const FETCH_DISTRICT_EXTERNALLAYERS_SUCCESS = 'FETCH_DISTRICT_EXTERNALLAYERS_SUCCESS';
export const FETCH_DISTRICT_EXTERNALLAYERS_FAILURE = 'FETCH_DISTRICT_EXTERNALLAYERS_FAILURE';
export const FETCH_DISTRICT_STYLES_REQUEST = 'FETCH_DISTRICT_STYLES_REQUEST';
export const FETCH_DISTRICT_STYLES_SUCCESS = 'FETCH_DISTRICT_STYLES_SUCCESS';
export const FETCH_DISTRICT_STYLES_FAILURE = 'FETCH_DISTRICT_STYLES_FAILURE';
// ---------------------------------------------------------------------------------------------------------------NOWE
export const FETCH_DISTRICT_PARCELS_REQUEST = 'FETCH_DISTRICT_PARCELS_REQUEST';
export const FETCH_DISTRICT_PARCELS_SUCCESS = 'FETCH_DISTRICT_PARCELS_SUCCESS';
export const FETCH_DISTRICT_PARCELS_FAILURE = 'FETCH_DISTRICT_PARCELS_FAILURE';

// ----------------------------------------------------------------------------------------USERS

export const CREATE_NEW_USER_SUCCESS = 'CREATE_NEW_USER_SUCCESS';
export const CREATE_NEW_USER_FAILURE = 'CREATE_NEW_USER_FAILURE';
export const CREATE_NEW_USER_REQUEST = 'CREATE_NEW_USER_REQUEST';

export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const LOGOUT_USER = 'LOGOUT_USER';

export const UPDATE_ROLE_FEATURES_SUCCESS = 'UPDATE_ROLE_FEATURES_SUCCESS';
export const UPDATE_ROLE_FEATURES_FAILURE = 'UPDATE_ROLE_FEATURES_FAILURE';
export const UPDATE_ROLE_FEATURES_REQUEST = 'UPDATE_ROLE_FEATURES_REQUEST';

export const ADD_ROLE_TO_USER_SUCCESS = 'ADD_ROLE_TO_USER_SUCCESS';
export const ADD_ROLE_TO_USER_FAILURE = 'ADD_ROLE_TO_USER_FAILURE';
export const ADD_ROLE_TO_USER_REQUEST = 'ADD_ROLE_TO_USER_REQUEST';

// ----------------------------------------------------------------------------------------DISTRICT
export const FETCH_PG_LAYER_DATA_REQUEST = 'FETCH_PG_LAYER_DATA_REQUEST';
export const FETCH_PG_LAYER_DATA_SUCCESS = 'FETCH_PG_LAYER_DATA_SUCCESS';
export const FETCH_PG_LAYER_DATA_FAILURE = 'FETCH_PG_LAYER_DATA_FAILURE';

export const FETCH_PGLAYERLIST_REQUEST = 'FETCH_PGLAYERLIST_REQUEST';
export const FETCH_PGLAYERLIST_SUCCESS = 'FETCH_PGLAYERLIST_SUCCESS';
export const FETCH_PGLAYERLIST_FAILURE = 'FETCH_PGLAYERLIST_FAILURE';

export const FETCH_UPDATE_STYLE_LIST_REQUEST = 'FETCH_UPDATE_STYLE_LIST_REQUEST';
export const FETCH_UPDATE_STYLE_LIST_SUCCESS = 'FETCH_UPDATE_STYLE_LIST_SUCCESS';
export const FETCH_UPDATE_STYLE_LIST_FAILURE = 'FETCH_UPDATE_STYLE_LIST_FAILURE';

export const DELETE_STYLE_REQUEST = 'DELETE_STYLE_REQUEST';
export const DELETE_STYLE_SUCCESS = 'DELETE_STYLE_SUCCESS';
export const DELETE_STYLE_FAILURE = 'DELETE_STYLE_FAILURE';

export const ADD_STYLE_REQUEST = 'ADD_STYLE_REQUEST';
export const ADD_STYLE_SUCCESS = 'ADD_STYLE_SUCCESS';
export const ADD_STYLE_FAILURE = 'ADD_STYLE_FAILURE';

export const ADD_STYLE_FILE_REQUEST = 'ADD_STYLE_REQUEST';
export const ADD_STYLE_FILE_SUCCESS = 'ADD_STYLE_SUCCESS';
export const ADD_STYLE_FILE_FAILURE = 'ADD_STYLE_FAILURE';

export const CHANGE_LAYER_STYLE_REQUEST = 'CHANGE_LAYER_STYLE_REQUEST';
export const CHANGE_LAYER_STYLE_SUCCESS = 'CHANGE_LAYER_STYLE_SUCCESS';
export const CHANGE_LAYER_STYLE_FAILURE = 'CHANGE_LAYER_STYLE_FAILURE';

export const PUBLISH_LAYER_REQUEST = 'PUBLISH_LAYER_REQUEST';
export const PUBLISH_LAYER_SUCCESS = 'PUBLISH_LAYER_SUCCESS';
export const PUBLISH_LAYER_FAILURE = 'PUBLISH_LAYER_FAILURE';

export const ADD_EXTERNAL_LAYER_REQUEST = 'ADD_EXTERNAL_LAYER_REQUEST';
export const ADD_EXTERNAL_LAYER_SUCCESS = 'ADD_EXTERNAL_LAYER_SUCCESS';
export const ADD_EXTERNAL_LAYER_FAILURE = 'ADD_EXTERNAL_LAYER_FAILURE';

export const DELETE_EXTERNAL_LAYER_REQUEST = 'DELETE_EXTERNAL_LAYER_REQUEST';
export const DELETE_EXTERNAL_LAYER_SUCCESS = 'DELETE_EXTERNAL_LAYER_SUCCESS';
export const DELETE_EXTERNAL_LAYER_FAILURE = 'DELETE_EXTERNAL_LAYER_FAILURE';

export const ADD_ROLE_REQUEST = 'ADD_ROLE_REQUEST';
export const ADD_ROLE_SUCCESS = 'ADD_ROLE_SUCCESS';
export const ADD_ROLE_FAILURE = 'ADD_ROLE_FAILURE';

export const DELETE_ROLE_REQUEST = 'DELETE_ROLE_REQUEST';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_FAILURE = 'DELETE_ROLE_FAILURE';

export const ADD_ROLE_LAYER_PERMISSIONS_REQUEST = 'ADD_ROLE_LAYER_PERMISSIONS_REQUEST';
export const ADD_ROLE_LAYER_PERMISSIONS_SUCCESS = 'ADD_ROLE_LAYER_PERMISSIONS_SUCCESS';
export const ADD_ROLE_LAYER_PERMISSIONS_FAILURE = 'ADD_ROLE_LAYER_PERMISSIONS_FAILURE';

export const DELETE_ROLE_LAYER_PERMISSIONS_REQUEST = 'DELETE_ROLE_LAYER_PERMISSIONS_REQUEST';
export const DELETE_ROLE_LAYER_PERMISSIONS_SUCCESS = 'DELETE_ROLE_LAYER_PERMISSIONS_SUCCESS';
export const DELETE_ROLE_LAYER_PERMISSIONS_FAILURE = 'DELETE_ROLE_LAYER_PERMISSIONS_FAILURE';

export const UPDATE_ROLE_LAYER_PERMISSIONS_REQUEST = 'UPDATE_ROLE_LAYER_PERMISSIONS_REQUEST';
export const UPDATE_ROLE_LAYER_PERMISSIONS_SUCCESS = 'UPDATE_ROLE_LAYER_PERMISSIONS_SUCCESS';
export const UPDATE_ROLE_LAYER_PERMISSIONS_FAILURE = 'UPDATE_ROLE_LAYER_PERMISSIONS_FAILURE';

export const UPDATE_ROLE_ATTRS_PERMISSIONS_REQUEST = 'UPDATE_ROLE_ATTRS_PERMISSIONS_REQUEST';
export const UPDATE_ROLE_ATTRS_PERMISSIONS_SUCCESS = 'UPDATE_ROLE_ATTRS_PERMISSIONS_SUCCESS';
export const UPDATE_ROLE_ATTRS_PERMISSIONS_FAILURE = 'UPDATE_ROLE_ATTRS_PERMISSIONS_FAILURE';

export const DELETE_GES_LAYER_REQUEST = 'DELETE_GES_LAYER_REQUEST';
export const DELETE_GES_LAYER_SUCCESS = 'DELETE_GES_LAYER_SUCCESS';
export const DELETE_GES_LAYER_FAILURE = 'DELETE_GES_LAYER_FAILURE';

export const FETCH_POIS_REQUEST = 'FETCH_POIS_REQUEST';
export const FETCH_POIS_SUCCESS = 'FETCH_POIS_SUCCESS';
export const FETCH_POIS_FAILURE = 'FETCH_POIS_FAILURE';
export const FETCH_HOTELS_REQUEST = 'FETCH_HOTELS_REQUEST';
export const FETCH_HOTELS_SUCCESS = 'FETCH_HOTELS_SUCCESS';
export const FETCH_HOTELS_FAILURE = 'FETCH_HOTELS_FAILURE';
export const FETCH_POIS_PROPS_REQUEST = 'FETCH_POIS_PROPS_REQUEST';
export const FETCH_POIS_PROPS_SUCCESS = 'FETCH_POIS_PROPS_SUCCESS';
export const FETCH_POIS_PROPS_FAILURE = 'FETCH_POIS_PROPS_FAILURE';
export const FETCH_HOTELS_PROPS_REQUEST = 'FETCH_HOTELS_PROPS_REQUEST';
export const FETCH_HOTELS_PROPS_SUCCESS = 'FETCH_HOTELS_PROPS_SUCCESS';
export const FETCH_HOTELS_PROPS_FAILURE = 'FETCH_HOTELS_PROPS_FAILURE';

export const CHANGE_GMINA_WYBIERZ = 'CHANGE_GMINA_WYBIERZ';

export const SIDEDESCRIPTION_VIEW = 'SIDEDESCRIPTION_VIEW';
export const SIDEDESCRIPTION_VIEW_PROJECT = 'SIDEDESCRIPTION_VIEW_PROJECT';

export const CHOSEN_PARCEL = 'CHOSEN_PARCEL';

export const FETCH_ALLDISTRICTSERVICES_REQUEST = 'FETCH_ALLDISTRICTSERVICES_REQUEST';
export const FETCH_ALLDISTRICTSERVICES_SUCCESS = 'FETCH_ALLDISTRICTSERVICES_SUCCESS';
export const FETCH_ALLDISTRICTSERVICES_FAILURE = 'FETCH_ALLDISTRICTSERVICES_FAILURE';

// ----------------------------------------------------------------------------------------POSTGEODATA
export const ADD_SHP_DATA_REQUEST = 'ADD_SHP_DATA_REQUEST';
export const ADD_SHP_DATA_SUCCESS = 'ADD_SHP_DATA_SUCCESS';
export const ADD_SHP_DATA_FAILURE = 'ADD_SHP_DATA_FAILURE';

export const ADD_GML_DATA_REQUEST = 'ADD_GML_DATA_REQUEST';
export const ADD_GML_DATA_SUCCESS = 'ADD_GML_DATA_SUCCESS';
export const ADD_GML_DATA_FAILURE = 'ADD_GML_DATA_FAILURE';

export const ADD_CSV_DATA_REQUEST = 'ADD_CSV_DATA_REQUEST';
export const ADD_CSV_DATA_SUCCESS = 'ADD_CSV_DATA_SUCCESS';
export const ADD_CSV_DATA_FAILURE = 'ADD_CSV_DATA_FAILURE';

export const ADD_SQLITE_DATA_REQUEST = 'ADD_SQLITE_DATA_REQUEST';
export const ADD_SQLITE_DATA_SUCCESS = 'ADD_SQLITE_DATA_SUCCESS';
export const ADD_SQLITE_DATA_FAILURE = 'ADD_SQLITE_DATA_FAILURE';

export const ADD_APPROVED_SQLITE_DATA_REQUEST = 'ADD_APPROVED_SQLITE_DATA_REQUEST';
export const ADD_APPROVED_SQLITE_DATA_SUCCESS = 'ADD_APPROVED_SQLITE_DATA_SUCCESS';
export const ADD_APPROVED_SQLITE_DATA_FAILURE = 'ADD_APPROVED_SQLITE_DATA_FAILURE';

export const FETCH_JOB_STATUS_REQUEST = 'FETCH_JOB_STATUS_REQUEST';
export const FETCH_JOB_STATUS_SUCCESS = 'FETCH_JOB_STATUS_SUCCESS';
export const FETCH_JOB_STATUS_FAILURE = 'FETCH_JOB_STATUS_FAILURE';

export const POST_NEW_POI_REQUEST = 'POST_NEW_POI_REQUEST';
export const POST_NEW_POI_SUCCESS = 'POST_NEW_POI_SUCCESS';
export const POST_NEW_POI_FAILURE = 'POST_NEW_POI_FAILURE';

export const UPDATE_NEW_POI_REQUEST = 'UPDATE_NEW_POI_REQUEST';
export const UPDATE_NEW_POI_SUCCESS = 'UPDATE_NEW_POI_SUCCESS';
export const UPDATE_NEW_POI_FAILURE = 'UPDATE_NEW_POI_FAILURE';

export const SAVE_NEW_POI_REQUEST = 'SAVE_NEW_POI_REQUEST';
export const SAVE_NEW_POI_SUCCESS = 'SAVE_NEW_POI_SUCCESS';
export const SAVE_NEW_POI_FAILURE = 'SAVE_NEW_POI_FAILURE';

export const DELETE_NEW_POI_REQUEST = 'DELETE_NEW_POI_REQUEST';
export const DELETE_NEW_POI_SUCCESS = 'DELETE_NEW_POI_SUCCESS';
export const DELETE_NEW_POI_FAILURE = 'DELETE_NEW_POI_FAILURE';

export const POST_NEW_HOTEL_REQUEST = 'POST_NEW_HOTEL_REQUEST';
export const POST_NEW_HOTEL_SUCCESS = 'POST_NEW_HOTEL_SUCCESS';
export const POST_NEW_HOTEL_FAILURE = 'POST_NEW_HOTEL_FAILURE';

export const UPDATE_NEW_HOTEL_REQUEST = 'UPDATE_NEW_HOTEL_REQUEST';
export const UPDATE_NEW_HOTEL_SUCCESS = 'UPDATE_NEW_HOTEL_SUCCESS';
export const UPDATE_NEW_HOTEL_FAILURE = 'UPDATE_NEW_HOTEL_FAILURE';

export const SAVE_NEW_HOTEL_REQUEST = 'SAVE_NEW_HOTEL_REQUEST';
export const SAVE_NEW_HOTEL_SUCCESS = 'SAVE_NEW_HOTEL_SUCCESS';
export const SAVE_NEW_HOTEL_FAILURE = 'SAVE_NEW_HOTEL_FAILURE';

export const DELETE_NEW_HOTEL_REQUEST = 'DELETE_NEW_HOTEL_REQUEST';
export const DELETE_NEW_HOTEL_SUCCESS = 'DELETE_NEW_HOTEL_SUCCESS';
export const DELETE_NEW_HOTEL_FAILURE = 'DELETE_NEW_HOTEL_FAILURE';

export const SUBMIT_ADV_SEARCH_REQUEST = 'SUBMIT_ADV_SEARCH_REQUEST';
export const SUBMIT_ADV_SEARCH_SUCCESS = 'SUBMIT_ADV_SEARCH_SUCCESS';
export const SUBMIT_ADV_SEARCH_FAILURE = 'SUBMIT_ADV_SEARCH_FAILURE';

export const DELETE_FORM_ATTR_REQUEST = 'DELETE_FORM_ATTR_REQUEST';
export const DELETE_FORM_ATTR_SUCCESS = 'DELETE_FORM_ATTR_SUCCESS';
export const DELETE_FORM_ATTR_FAILURE = 'DELETE_FORM_ATTR_FAILURE';

export const UPDATE_FORM_ATTR_REQUEST = 'UPDATE_FORM_ATTR_REQUEST';
export const UPDATE_FORM_ATTR_SUCCESS = 'UPDATE_FORM_ATTR_SUCCESS';
export const UPDATE_FORM_ATTR_FAILURE = 'UPDATE_FORM_ATTR_FAILURE';

export const UPLOAD_PARCEL_SUCCESS = 'UPLOAD_PARCEL_SUCCESS';

export const FETCH_GRAVES_REQUEST = 'FETCH_GRAVES_REQUEST';
export const FETCH_GRAVES_SUCCESS = 'FETCH_GRAVES_SUCCESS';
export const FETCH_GRAVES_FAILURE = 'FETCH_GRAVES_FAILURE';

export const FETCH_ZARZAD_REQUEST = 'FETCH_ZARZAD_REQUEST';
export const FETCH_ZARZAD_SUCCESS = 'FETCH_ZARZAD_SUCCESS';
export const FETCH_ZARZAD_FAILURE = 'FETCH_ZARZAD_FAILURE';

export const FETCH_GRAVEYARD_REQUEST = 'FETCH_GRAVEYARD_REQUEST';
export const FETCH_GRAVEYARD_SUCCESS = 'FETCH_GRAVEYARD_SUCCESS';
export const FETCH_GRAVEYARD_FAILURE = 'FETCH_GRAVEYARD_FAILURE';

export const FETCH_SECTORS_REQUEST = 'FETCH_SECTORS_REQUEST';
export const FETCH_SECTORS_SUCCESS = 'FETCH_SECTORS_SUCCESS';
export const FETCH_SECTORS_FAILURE = 'FETCH_SECTORS_FAILURE';

// ----------------------------------------------------------------------------------------DICTIONARIES
export const ADD_DICT_REQUEST = 'ADD_DICT_REQUEST';
export const ADD_DICT_SUCCESS = 'ADD_DICT_SUCCESS';
export const ADD_DICT_FAILURE = 'ADD_DICT_FAILURE';

export const DELETE_DICT_REQUEST = 'DELETE_DICT_REQUEST';
export const DELETE_DICT_SUCCESS = 'DELETE_DICT_SUCCESS';
export const DELETE_DICT_FAILURE = 'DELETE_DICT_FAILURE';

export const ADD_DICT_ATTRS_REQUEST = 'ADD_DICT_ATTRS_REQUEST';
export const ADD_DICT_ATTRS_SUCCESS = 'ADD_DICT_ATTRS_SUCCESS';
export const ADD_DICT_ATTRS_FAILURE = 'ADD_DICT_ATTRS_FAILURE';

export const ADD_DICT_VALS_REQUEST = 'ADD_DICT_VALS_REQUEST';
export const ADD_DICT_VALS_SUCCESS = 'ADD_DICT_VALS_SUCCESS';
export const ADD_DICT_VALS_FAILURE = 'ADD_DICT_VALS_FAILURE';

export const GET_DICT_VALS_REQUEST = 'GET_DICT_VALS_REQUEST';
export const GET_DICT_VALS_SUCCESS = 'GET_DICT_VALS_SUCCESS';
export const GET_DICT_VALS_FAILURE = 'GET_DICT_VALS_FAILURE';

export const GET_DICT_ATTRS_REQUEST = 'GET_DICT_ATTRS_REQUEST';
export const GET_DICT_ATTRS_SUCCESS = 'GET_DICT_ATTRS_SUCCESS';
export const GET_DICT_ATTRS_FAILURE = 'GET_DICT_ATTRS_FAILURE';

export const ADD_COMOPSITION_REQUEST = 'ADD_COMOPSITION_REQUEST';
export const ADD_COMOPSITION_SUCCESS = 'ADD_COMOPSITION_SUCCESS';
export const ADD_COMOPSITION_FAILURE = 'ADD_COMOPSITION_FAILURE';

export const INCREMENT = 'BOUNCE_COUNTER_INCREMENT';
export const SEARCHBOX_STATUS = 'SEARCHBOX_STATUS';
export const TOGGLE_SEARCHBOX_STATUS = 'TOGGLE_SEARCHBOX_STATUS';

export const CHANGE_PRINT_STATUS = 'CHANGE_PRINT_STATUS';
export const CHANGE_PRINT_FORMAT = 'CHANGE_PRINT_FORMAT';
export const CHANGE_PRINT_ORIENTATION = 'CHANGE_PRINT_ORIENTATION';
export const FINAL_PRINTING_TRIGGERED = 'FINAL_PRINTING_TRIGGERED';
export const SET_WINDOW_VIEWPORT = 'SET_WINDOW_VIEWPORT';
export const SET_PRINT_VIEWPORT = 'SET_PRINT_VIEWPORT';
export const CHANGE_PRINT_PDF_STATUS = 'CHANGE_PRINT_PDF_STATUS';

export const DELETE_COMOPSITION_REQUEST = 'DELETE_COMOPSITION_REQUEST';
export const DELETE_COMOPSITION_SUCCESS = 'DELETE_COMOPSITION_SUCCESS';
export const DELETE_COMOPSITION_FAILURE = 'DELETE_COMOPSITION_FAILURE';

export const FETCH_POWIATY_REQUEST = 'FETCH_POWIATY_REQUEST';
export const FETCH_POWIATY_SUCCESS = 'FETCH_POWIATY_SUCCESS';
export const FETCH_POWIATY_FAILURE = 'FETCH_POWIATY_FAILURE';

export const FETCH_GMINY_REQUEST = 'FETCH_GMINY_REQUEST';
export const FETCH_GMINY_SUCCESS = 'FETCH_GMINY_SUCCESS';
export const FETCH_GMINY_FAILURE = 'FETCH_GMINY_FAILURE';

export const UPDATE_START_ROUTE = 'UPDATE_START_ROUTE';
export const UPDATE_END_ROUTE = 'UPDATE_END_ROUTE';
export const CLEAR_ROUTE = 'CLEAR_ROUTE';
export const CHANGE_ZOOM = 'CHANGE_ZOOM';
export const CHANGE_CENTER = 'CHANGE_CENTER';
export const PREV_MAP = 'PREV_MAP';
export const NEXT_MAP = 'NEXT_MAP';

export const FETCH_PARCEL_ID_REQUEST = 'FETCH_PARCEL_ID_REQUEST';
export const FETCH_PARCEL_ID_SUCCESS = 'FETCH_PARCEL_ID_SUCCESS';
export const FETCH_PARCEL_ID_FAILURE = 'FETCH_PARCEL_ID_FAILURE';

// ----------------------------------------------------------------------------------------LAYERS
export const SET_LAYER_VISIBILITY = 'SET_LAYER_VISIBILITY';
export const SET_GROUP_VISIBILITY = 'SET_GROUP_VISIBILITY';
export const SET_CURRENT_MAP_COMPOSITION = 'SET_CURRENT_MAP_COMPOSITION';
export const SET_CURRENT_MINIMAP_COMPOSITION = 'SET_CURRENT_MINIMAP_COMPOSITION';
export const SET_LAYERS_AREA = 'SET_LAYERS_AREA';

// ----------------------------------------------------------------------------------------MAP TOOLS
export const SET_MEASUREMENT_TOOL = 'SET_MEASUREMENT_TOOL';
export const DISABLE_MEASUREMENT_TOOLS = 'DISABLE_MEASUREMENT_TOOLS';
export const ADD_POI_POINT = 'ADD_POI_POINT';
export const RESET_ADD_POI_TOOL = 'RESET_ADD_POI_TOOL';
export const RESET_MANAGAE_POI_TOOL = 'RESET_MANAGAE_POI_TOOL';
export const ADD_HOTEL_POINT = 'ADD_HOTEL_POINT';
export const RESET_ADD_HOTEL_TOOL = 'RESET_ADD_HOTEL_TOOL';
export const RESET_MANAGAE_HOTEL_TOOL = 'RESET_MANAGAE_HOTEL_TOOL';

export const TOGGLE_SPATIAL_ANALYSIS = 'ENABLE_SPATIAL_ANALYSIS';
export const CHANGE_SPATIAL_ANALYSIS_CONFIG = 'CHANGE_SPATIAL_ANALYSIS_CONFIG';
export const CLEAR_SPATIAL_ANALYSIS_CONFIG = 'CLEAR_SPATIAL_ANALYSIS_CONFIG';

export const FETCH_ARMS = 'FETCH_ARMS';
export const FETCH_ARMS_SUCCESS = 'FETCH_ARMS_SUCCESS';
export const FETCH_ARMS_FAILURE = 'FETCH_ARMS_FAILURE';

export const FOOTER_HEIGHT = 'FOOTER_HEIGHT';

export const FETCH_AVAILABLE_SERVICES_REQUEST = 'FETCH_AVAILABLE_SERVICES_REQUEST';
export const FETCH_AVAILABLE_SERVICES_SUCCESS = 'FETCH_AVAILABLE_SERVICES_SUCCESS';
export const FETCH_AVAILABLE_SERVICES_FAILURE = 'FETCH_AVAILABLE_SERVICES_FAILURE';

export const SET_CURRENT_DISTRICT = 'SET_CURRENT_DISTRICT';
export const UPDATE_USER = 'UPDATE_USER';

export const ADDRESS_POLYGON = 'ADDRESS_POLYGON';
export const ONCLICK_PARCEL = 'ONCLICK_PARCEL';

export const START_ESERVICE = 'START_ESERVICE';
export const SUCCESS_ESERVICE = 'SUCCESS_ESERVICE';
export const FAILURE_ESERVICE = 'FAILURE_ESERVICE';

export const RECTANGLE_ZOOM_IN = 'RECTANGLE_ZOOM_IN';

export const RECTANGLE_BLOCKING_TOGGLE = 'RECTANGLE_BLOCKING_TOGGLE';

export const BUILDING_DRAW_TOOL_TOGGLE = 'BUILDING_DRAW_TOOL_TOGGLE';
export const BUILDING_DRAW_TOOL_GET_POINT = 'BUILDING_DRAW_TOOL_GET_POINT';
export const BUILDING_DRAW_TOOL_DATA = 'BUILDING_DRAW_TOOL_DATA';
export const BUILDING_DRAW_TOOL_PARCELS = 'BUILDING_DRAW_TOOL_PARCELS';
export const BUILDING_DRAW_TOOL_VALIDATE = 'BUILDING_DRAW_TOOL_VALIDATE';
export const BUILDING_DRAW_TOOL_PDF = 'BUILDING_DRAW_TOOL_PDF';

export const FETCH_DRAW_TOOL_LIMITS_REQUEST = 'FETCH_DRAW_TOOL_LIMITS_REQUEST';
export const FETCH_DRAW_TOOL_LIMITS_SUCCESS = 'FETCH_DRAW_TOOL_LIMITS_SUCCESS';
export const FETCH_DRAW_TOOL_LIMITS_FAIL = 'FETCH_DRAW_TOOL_LIMITS_FAIL';

export const FETCH_PREFIXES_REQUEST = 'FETCH_PREFIXES_REQUEST';
export const FETCH_PREFIXES_SUCCESS = 'FETCH_PREFIXES_SUCCESS';
export const FETCH_PREFIXES_FAIL = 'FETCH_PREFIXES_FAIL';
export const DELETE_LAYER_FAILURE = 'DELETE_LAYER_FAILURE';
export const DELETE_LAYER_REQUEST = 'DELETE_LAYER_REQUEST';
export const DELETE_LAYER_SUCCESS = 'DELETE_LAYER_SUCCESS';

export const CHOOSE_GRAVE = 'CHOOSE_GRAVE';
export const CHOOSE_GRAVEYARD = 'CHOOSE_GRAVEYARD';

const leftCol = 'col-sm-1';
const labelCol = 'col-sm-3';
const inputCol = 'col-sm-7';
const rightCol = 'col-sm-1';
const inputStyle = { borderRadius: '0' };
const errorSpanStyle = {
  color: 'red',
  fontSize: '10px',
};
// really simple styles
const labelStyle = { marginTop: '.5rem' };
const rowStyle = { marginTop: '15px' };

export const PanelStyle = {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
};

export const langTable = [
  { kompWarst: ['Dostępne kompozycje warstw', 'Available layer compositions', 'Verfügbare Schichtzusammensetzungen'] },
  { dostepneWarstwy: ['Dostępne warstwy', 'Available layers', 'Verfügbare Ebenen'] },
  { dzialkaEwi: ['Działka ewidencyjna', 'Registered parcel of land', 'Parzelle'] },
  { infoOgolne: ['Informacje ogólne', 'General information', 'Allgemeine Informationen'] },
  { kontoUzyt: ['Konto użytkownika', 'User account', 'Benutzerkonto'] },
  { legenda: ['Legenda', 'Map key', 'Zeichenerklärung'] },
  { linia: ['Linia', 'Line', 'Linie'] },
  { maksMin: ['Maksymalizuj/Minimalizuj', 'Maximize/Minimize', 'Maximieren/Minimieren'] },
  { narzedzia: ['Narzędzia', 'Tools', 'Werkzeuge'] },
  { rectZoom: ['Narzędzie do powiększania oknem', 'Zoom window', 'Zoom-Fenster'] },
  { nastCel: ['Następny cel', 'Next view', 'Nächste Ansicht'] },
  { niezalogowany: ['Niezalogowany', 'You are not logged', 'Sie sind nicht angemeldet'] },
  { ofertaInvest: ['Oferta inwestycyjna', 'Investment offers', 'Investitionsangebote'] },
  { panelWarstw: ['Panel warstw', 'Map contents', 'Inhalt der Landkarte'] },
  { pokazHaslo: ['Pokaż hasło', 'Show password', 'Passwort anzeigen'] },
  { lang: ['Polski', 'Deutsch', 'English'] },
  { poprzCel: ['Poprzedni cel', 'Previous view', 'Frühere Ansicht'] },
  { powierzchnia: ['Powierzchnia', 'Polygon', 'Polygon'] },
  { wezPunkt: ['Przechwyć współrzędne punktu', 'Point coordinates', 'Punktkoordinaten'] },
  { punkt: ['Punkt', 'Point', 'Punkt'] },
  { syntezatorMow: ['Syntezator mowy', 'Speech synthesizer', 'Sprachsynthesizer'] },
  { ustawienia: ['Ustawienia', 'Settings', 'Einstellungen'] },
  { utwKont: ['Utwórz konto', 'Create an account', 'Neuer Account'] },
  { warstwy: ['Warstwy', 'Layers', 'Lagen'] },
  { wyczysc: ['Wyczyść', 'Clear', 'Löschen'] },
  { wyczyscPom: ['Wyczyść pomiary', 'Clear measurements', 'Messungen löschen'] },
  { wydruk: ['Wydruk', 'Print', 'Ausdruck'] },
  { wykPom: ['Wykonaj pomiar', 'Measurements', 'Messungen'] },
  { pomOdcinka: ['Wykonaj pomiar długości odcinka', 'Measure distance', 'Entwernung messen'] },
  { pomPowierzchni: ['Wykonaj pomiar powierzchni', 'Measure area', 'Fläche messen'] },
  { wyloguj: ['Wyloguj', 'Logout', 'Abmelden'] },
  { wyszOfert: ['Wyszukiwarka ofert inwestycyjnych', 'Investment offers', 'Investitionsangebote'] },
  { zalogowanyJako: ['Zalogowany jako', 'Login as', 'Anmeldung als'] },
  { zalogujEmail: ['Zaloguj z użyciem email', 'Login with e-mail', 'Login mit e-mail'] },
  { zapHasla: ['Zapomniałeś hasła?', 'Forgot Password?', 'Kennwort vergessen?'] },
  { zdefiniujObsz: ['Zdefiniuj obszar wyświetlania', 'Define area/zone', 'Definiere Bereich'] },
  { zmianaJezyka: ['Zmiana języka', 'Language', 'Sprache'] },
  { opisObiektu: ['Opis obiektu', 'Description', 'Beschreibung'] },,
  { znajdzGrob: ['Znajdź grób', 'Find grave', 'Graves suchen'] },
  { wyszGrob: ['Wyszukiwarka grobów', 'Graves search', 'Finde das Grab'] },
  { zaprojektujInwestycje: ['Zaprojektuj inwestycję', 'Design an investment', 'Entwerfen Sie eine Investition'] },
  { kartaInfo: ['Karta informacyjna', 'Information card', 'Informationskarte'] },
  { galeria: ['Galeria', 'Gallery', 'Galerie'] },
  { images: ['Zdjęcia', 'Photos', 'Fotos'] },
  { zaprojektuj: ['Zaprojektuj', 'Design', 'Design'] },
  { szczegoly: ['Szczegóły', 'Details', 'Details'] },
  { kontakt: ['Kontakt', 'Contact', 'Kontakt'] },
  { szukajDzialke: ['Szukaj działkę', 'Search plot', 'Suche nach einem Grundstück'] },
  { maxmin: ['Maksymalizuj/minimalizuj', 'Maximize / Minimize', 'Maximieren / Minimieren'] },
  { powiekszOknem: ['Narzędzie do powiększania oknem', 'Window magnifying tool', 'Fenstervergrößerungswerkzeug'] },
  { wysokoscInvest: ['Wysokośc budynku [m]', 'Building height [m]', 'Gebäudehöhe [m]'] },
  { zapNewInvest: ['Zaprojektuj nową inwestycję', 'Design a new investment', 'Entwerfen Sie eine neue Investition' ]},
  { widok3d: ['Widok 3D', '3D View', '3D-Ansicht']},
  { wybierz: ['Wybierz...', 'Select...', 'Wählen...']},
  { typDachu: ['Wybierz typ dachu', 'Choose the type of roof', 'Wählen Sie die Kunst des Daches']},
  { plaskiDach: ['Plaski', 'Flat', 'Wohnung']},
  { jednoDach: ['Jednospadowy', 'Pent', 'Eingeschlossen']},
  { dwuDach: ['Dwuspadowy', 'Gable', 'Giebel']},
  { katDachu: ['Podaj kąt dachu', 'Enter the roof angle', 'Geben Sie den Dachwinkel ein']},
  { wieloDach: ['Wielospadowy', 'Multi-pitched', 'Mehrteiliges']},
  { powierzchniaInvest: ['Powierzchnia inwestycji', 'Investment area',  'Investitionsbereich']},
  { wybralesTeren: ['Wybrałeś teren inwestycyjny', 'You have chosen an investment area', 'Sie haben einen Investitionsbereich gewählt']},
  { zaDuzaWysokosc: ['Podana wysokość budynku jest niezgodna z MPZP dla strefy w której mieści się zaprojektowana geometria',
                     'The given height of the building is inconsistent with the MPZP for the zone in which the designed geometry is located',
                     'Die angegebene Höhe des Gebäudes stimmt nicht mit der MPZP für die Zone überein, in der sich die entworfene Geometrie befindet']},
  { infoInvest: ['Podaj szczegóły projektowanej inwestycji.', 'Provide details of the designed investment.', 'Geben Sie Details zur geplanten Investition an.']},
  { istInw: ['Teren zainwestowany', 'Land invested', 'Land investiert'] },
  { istInwTitle: ['Informacje o terenie zainwestowanym', 'Information about the invested area', 'Informationen über das investierte Gebiet'] },
  { nazwa: ['Inwestor', 'Investor', 'Investor'] },
  { branza: ['Branża', 'Industry', 'Branche'] },
  { opis: ['Opis', 'Description', 'Beschreibung'] },
  { rozpocznijProjektowanie: ['Rozpocznij projektowanie', 'Start designing', 'Beginne zu entwerfen'] },

  { niezalogowany: ['Niezalogowany', 'Not logged', 'Nicht angemeldet'] },
  { zagolonawyJako: ['Zalogowany jako ', 'Logged in as ', 'Angemeldet als '] },
  { zaloguj: ['Zaloguj', 'Log in', 'Anmelden'] },
  { wyloguj: ['Wyloguj', 'Log out', 'Abmelden'] },
  { utwKonto: ['Utwórz konto', 'Create an account', 'Erstelle ein Konto'] },
  { haslo: ['Hasło', 'Password', 'Kennwort'] },
  { zapomnialesHaslo: ['Zapomniałeś hasła?', 'Have you forgotten your password?', 'Hast du dein Passwort vergessen?'] },
  { utwNoweHaslo: ['Utwórz nowe konto', 'Create new account', 'Erstellen Sie ein neues Konto'] },
  { wypPoniPolaNoweHaslo:
  ['Wypełnij poniższe pola aby utworzyć nowe konto',
    'Fill out the fields below to create a new account',
    'Füllen Sie die folgenden Felder aus, um ein neues Konto zu erstellen']
  },
  { imie: ['Imię', 'First Name', 'Name'] },
  { wprowadzImie: ['Wprowadź imię', 'Enter the first name', 'Geben Sie den Vornamen ein'] },
  { nazwisko: ['Nazwisko', 'Second Name', 'Familienname'] },
  { wprowadzEmail: ['Wprowadź swój adres email', 'Enter your email address', 'Geben Sie Ihre E-Mail-Adresse ein'] },
  { wprHasloMusiZawMin8Zn: ['Wprowadź hasło - musi zawierać minimum 8 znaków',
  'Enter password - must contain a minimum of 8 characters',
  'Passwort eingeben - muss mindestens 8 Zeichen enthalten'] },
  { powtHaslo: ['Powtórz hasło', 'Repeat password', 'Passwort wiederholen'] },
  { powtWprowadzoneHaslo: ['Powtórz wprowadzone hasło', 'Repeat the password entered', 'Wiederholen Sie das eingegebene Passwort'] },
  { powiatIGmina: ['Powiat i Gmina', 'Poviat and Commune', 'Poviat und Kommune'] },
  { wybierzPowiat: ['Wybierz powiat...', 'Choose a district...', 'Wähle einen Bezirk...'] },
  { wybierzGmine: ['Wybierz gminę...', 'Choose a municipality...', 'Wähle eine Gemeinde...'] },
  { miejscowosc: ['Miejscowość', 'Place', 'Platz'] },
  { wprNazwMiejsc: ['Wprowadź nazwę miejscowości', 'Enter the city name', 'Geben Sie den Namen der Stadt ein'] },
  { zarejestruj: ['Zarejestruj', 'Register', 'Registrieren'] },

  { analizyPrzestrzenne: ['Analizy przestrzenne', 'Spatial analysis', 'Räumliche Analyse'] },
  { analizy: ['Analizy', 'analyzes'] },
  { trasa: ['Trasa', 'Route', ''] },
  { warstwaPierw: ['Warstwa pierwsza', 'First layer'] },
  { typZapPrzes: ['Typ zapytania przestrzennego', 'The spatial query type'] },
  { warstwDruga: ['Warstwa druga', 'Second layer'] },

  { zglos: ['Zgłoś', 'Eport', 'Bericht'] },
  { edytuj: ['Edytuj', 'Edit', 'Bearbeiten'] },
  { zglosHotel: ['Zgłoś hotele', 'Report the hotel', 'Melde das Hotel'] },
  { edytujHotele: ['Edytuj hotele', 'Edit hotels', 'Hotels bearbeiten'] },
  { dodawObiektow: ['Dodawanie obiektów', 'Adding objects', 'Objekte hinzufügen'] },
  { edycjaObiektu: ['Edycja obiektu', 'Editing an object', 'Bearbeiten eines Objekts'] },

  { syntezatorMowy: ['Syntezator mowy', 'Speech synthesizer', 'Sprachsynthesizer'] },
  { pogladWydruku: ['Podgląd wydruku', 'Print Preview', 'Druckvorschau'] },
  { ustawieniaDruku: ['Ustawienia druku', 'Print settings', 'Druckeinstellungen'] },
  { orientacja: ['Orientacja', 'Orientation', 'Orientierung'] },
  { pionowo: ['pionowo', 'perpendicularly', 'aufrecht'] },
  { poziomo: ['poziomo', 'horizontally', 'horizontal'] },

  { anuluj: ['Poziomo', 'Cancel', 'Stornieren'] },
  { genWydruk: ['Generuj wydruk', 'Generate a printout', 'Einen Ausdruck erzeugen'] },
  { wybWarstwy: ['Wybierz warstwy', 'Select layers', 'Wählen Sie Ebenen'] },
  { wydrukPDF: ['Wydruk PDF', 'Printout PDF', 'Ausdruck PDF'] },
  { sidebarInstructions: [
    {
      aaa: 'Kliknij',
      bbb: '"Rozpocznij"',
      ccc: 'aby zacząć projektowanie swojej inwestycji.',
      ddd: 'Wrysuj budynek na mapę w obszarze inwestycji',
      eee: 'Gdy utworzysz zamierzony obrys inwestycji kliknij przycisk',
      fff: '"Zatwierdź"',
      ggg: 'Legenda mapy znajduje się w panelu',
      hhh: '"WARSTWY"',
      iii: 'Możesz dowolnie modyfikować widok mapy włączając/wyłączając poszczególne warstwy np. dane sieci uzbrojenia terenu (GESUT), dane miejscowych planów (MPZP).',
    },
    {
      aaa: 'Click',
      bbb: '"Begin"',
      ccc: 'to start designing your investment.',
      ddd: 'Draw the building on the map in the area of investment',
      eee: 'When you create the intended investment outline, click',
      fff: '"Confirm"',
      ggg: 'The map legend is located in the panel',
      hhh: '"Layers"',
      iii: 'You can freely modify the map view by enabling / disabling individual layers, eg data of the utilities network (GESUT), data of local plans (MPZP).',
    },
    {
      aaa: 'Klick',
      bbb: '"Begin"',
      ccc: 'um mit der Gestaltung Ihrer Investition zu beginnen',
      ddd: 'Zeichnen Sie das Gebäude auf der Karte im Investitionsbereich',
      eee: 'Wenn Sie die beabsichtigte Investitionsumrandung erstellen, klicken Sie auf',
      fff: '"Bestätigen"',
      ggg: 'Die Kartenlegende befindet sich im Panel',
      hhh: '"LAYERS"',
      iii: 'Sie können die Kartenansicht frei ändern, indem Sie einzelne Layer aktivieren / deaktivieren, z. B. Daten des Versorgungsnetzwerks (GESUT), Daten lokaler Pläne (MPZP).',
    }
  ]
  },
  { obrebNr: ['Obręb nr:', 'Area No.:', 'Bereich Nr.:'] },
  { dzialkaNr: ['Działka nr:', 'Plot No.:', 'Plot Nr.:'] },
  { przeznaczenie: ['Przeznaczenie:', 'Destiny:', 'Zweck:'] },
  { symbol: ['Symbol:', 'Symbol:', 'Symbol:'] },
  { powDzialki: ['Powierzchnia działki:', 'Land area:', 'Fläche des Grundstücks:'] },
  { dataUchwaleniaMpzp: ['Data uchwalenia MPZP:', 'Date of adoption of MPZP:', 'Datum der Annahme von MPZP:'] },
  { uchwalaMpzp: ['Uchwała MPZP:', 'MPZP resolution:', 'MPZP-Auflösung:'] },
  { trescUchwalyMpzp: ['Treść uchwały MPZP:', 'The content of the MPZP resolution:', 'Der Inhalt der MPZP-Auflösung:'] },
  { rysunekMpzp: ['Rysunek MPZP:', 'Drawing LSDP:', 'MPZP zeichnen:'] },
  { naniesPktNaMape: ['Nanieś punkty na mapę', 'Put points on the map', 'Punkte auf die Karte setzen'] },
  {
    geometryWarning: [
      'Geometria projektu nie zawiera się w obszarze wybranej oferty inwestycyjnej, lub przekracza nieprzekraczalną linię zabudowy.',
      'The geometry of the project is not included in the area of the selected investment offer, or exceeds the impassable building line.',
      'Die Geometrie des Projekts ist nicht im Bereich des ausgewählten Investitionsangebots enthalten, oder überschreitet die unpassierbare Gebäudelinie.',
    ],
  },
  { podgladWydruku: ['Podgląd wydruku', 'Print Preview', 'Druckvorschau'] },
  { ustawieniaDruku: ['Ustawienia druku:', 'Print settings:', 'Druckeinstellungen:'] },
  { orientacja: ['Orientacja', 'Orientation', 'Ausrichtung'] },
  { generujPdf: ['Generuj PDF', 'Generate PDF', 'PDF generieren'] },
  { generujWydruk: ['Generuj wydruk', 'Generate the printout'] },
  { wybierzWarstwy: ['Wybierz warstwy', 'Choose layers', 'Wählen Sie Ebenen'] },
  { dostKompWarstw: ['Dostępne kompozycje warstw', 'Available layer compositions', 'Verfügbare Schichtzusammensetzungen'] },

  { przedInvest: ['Przedmiot inwestycjny', 'Investment subject', 'Anlagethema'] },
  { przeznaczenieInvest: ['Przeznaczenie inwestycji', 'The purpose of the investment', 'Der Zweck der Investition'] },
  { formaWladowania: ['Forma władania', 'Form of wielding', 'Form der Ausübung'] },
  { dostInfraTech: ['Dostępność infrastruktury technicznej', 'Availability of technical infrastructure', 'Verfügbarkeit der technischen Infrastruktur'] },
  { powNieruchoOd: ['Powierzchnia nieruchomości od', 'Real estate area from', 'Immobiliengebiet von'] },
  { powNierzuchDo: ['Powierzchnia nieruchomości do', 'Real estate area to', 'Immobiliengebiet bis'] },
  { szukaj: ['szukaj', 'search', 'suche'] },
  { brakOferty: ['Brak ofert o podanych parametrach!', 'No offers with given parameters!', 'Keine Angebote mit vorgegebenen Parametern!'] },
  { pozaObszar: ['Naniesiony punkt wykracza poza teren wybranej oferty inwestycyjnej lub przekracza linię zabudowy!', 'The applied point goes beyond the working area of the investment.', 'Der angewendete Punkt geht über den Arbeitsbereich der Investition hinaus.']},
  { wykonajPomiar: ['Wykonaj pomiar długość odcinka/prostej', 'Take the length / straight line measurement', 'Nehmen Sie die Längen- / Geradenmessung vor']}
];



// WEBPACK FOOTER //
// src/constants/index.js